(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bina-project-set"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('bina-project-set'))customElements.define('bina-project-set',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      this.form=this.querySelector('[data-set-form]');this.button=this.querySelector('[data-set-submit]');
      this.money=new Intl.NumberFormat(this.dataset.locale||'en',{style:'currency',currency:this.dataset.currency||'INR'});
      this.form.addEventListener('change',()=>this.update());
      this.form.addEventListener('submit',event=>this.add(event));this.update();
    }
    selection(){return [...this.querySelectorAll('.bina-set__item')].filter(el=>el.querySelector('[data-set-check]').checked).map(el=>{const option=el.querySelector('select').selectedOptions[0];return option?{id:Number(option.value),quantity:Number(option.dataset.quantity)||1,price:Number(option.dataset.price)}:null}).filter(Boolean)}
    update(){
      this.querySelectorAll('.bina-set__item').forEach(el=>{const option=el.querySelector('select').selectedOptions[0];el.querySelector('[data-set-price]').textContent=option?this.money.format(Number(option.dataset.price)*(Number(option.dataset.quantity)||1)/100):''});
      const items=this.selection();this.querySelector('[data-set-total]').textContent=this.money.format(items.reduce((total,item)=>total+item.price*item.quantity,0)/100);this.button.disabled=!items.length;
    }
    async add(event){
      event.preventDefault();const items=this.selection();if(!items.length)return;
      this.button.disabled=true;this.button.setAttribute('aria-busy','true');const error=this.querySelector('[data-set-error]');error.hidden=true;
      try{const response=await fetch(this.dataset.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items.map(({id,quantity})=>({id,quantity}))})});const result=await response.json();if(!response.ok)throw new Error(result.description||this.dataset.error);window.location.assign(this.dataset.root+'cart');}
      catch(problem){error.textContent=problem.message||this.dataset.error;error.hidden=false;this.update();this.button.removeAttribute('aria-busy');}
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bina-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bina-recently-viewed')) {
    customElements.define('bina-recently-viewed', class extends HTMLElement {
      connectedCallback() {
        if (this.ready || this.loaded) return;
        this.ready = true;
        const key = 'bina-recent-v2-' + this.dataset.mode;
        let history = [];
        try {
          history = JSON.parse(localStorage.getItem(key) || '[]');
          if (!Array.isArray(history)) history = [];
        } catch {}
        history = history.filter(handle => typeof handle === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(handle));
        const previous = [...new Set(history)].filter(handle => handle !== this.dataset.handle).slice(0, 4);
        if (this.dataset.handle) {
          try { localStorage.setItem(key, JSON.stringify([this.dataset.handle, ...previous].slice(0, 5))); } catch {}
        }
        if (!previous.length) return;
        this.dataset.state = 'waiting';
        const start = () => {
          this.observer?.disconnect();
          this.loadCards(previous);
        };
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) start();
          }, { rootMargin: '400px 0px' });
          this.observer.observe(this.closest('.shopify-section') || this.parentElement);
        } else {
          start();
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.ready = false;
      }
      async loadCards(previous) {
        if (this.loading || this.loaded) return;
        this.loading = true;
        this.dataset.state = 'loading';
        const cards = await Promise.all(previous.map(async handle => {
          try {
            const response = await fetch(this.dataset.root + 'products/' + encodeURIComponent(handle) + '?section_id=bina-recent-card');
            if (!response.ok) return null;
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const card = html.querySelector('.bina-recent__card');
            return card?.dataset.productMode === this.dataset.mode ? card : null;
          } catch { return null; }
        }));
        this.loading = false;
        if (!this.isConnected) return;
        this.querySelector('.bina-recent__grid').replaceChildren(...cards.filter(Boolean));
        this.loaded = true;
        this.dataset.state = 'complete';
        if (cards.some(Boolean)) this.hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-featured-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('bina-collection-tabs'))customElements.define('bina-collection-tabs',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      const tabs=Array.from(this.querySelectorAll('[role="tab"]'));
      const activate=tab=>{
        tabs.forEach(item=>{const selected=item===tab;item.setAttribute('aria-selected',String(selected));item.tabIndex=selected?0:-1;const panel=this.querySelector('[id="'+item.getAttribute('aria-controls')+'"]');if(panel)panel.hidden=!selected;});
      };
      tabs.forEach((tab,index)=>{
        tab.addEventListener('click',event=>{if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;event.preventDefault();activate(tab);});
        tab.addEventListener('keydown',event=>{
          let next=index;
          if(event.key==='ArrowRight')next=(index+1)%tabs.length;
          else if(event.key==='ArrowLeft')next=(index-1+tabs.length)%tabs.length;
          else if(event.key==='Home')next=0;
          else if(event.key==='End')next=tabs.length-1;
          else if(event.key===' '||event.key==='Enter'){event.preventDefault();activate(tab);return;}
          else return;
          event.preventDefault();activate(tabs[next]);tabs[next].focus();
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('bina-footer-menu')) {
    customElements.define('bina-footer-menu', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.updateLayout = () => { this.details.open = !this.mobile.matches; };
        this.mobile.addEventListener('change', this.updateLayout);
        this.updateLayout();
      }
      disconnectedCallback() {
        this.mobile.removeEventListener('change', this.updateLayout);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
